const getEnvUrl = (envVariableUrl) => new URL(envVariableUrl, window.location.origin).href;

export default getEnvUrl;
